export default "__VITE_PUBLIC_ASSET__820d576e__"